// extracted by mini-css-extract-plugin
module.exports = {"ActionLeague":"ActionLeague-17tp14xD","slideItem":"slideItem-30a-c1xG","last":"last-2eeYQGVb slideItem-30a-c1xG","text_wrap":"text_wrap-16PHGXo6"};